import { FormGroup, Grid, Typography } from "@material-ui/core";
import moment from "moment";
import DateField from "./date";
import { FormLabel } from "@mui/material";
import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function FromToDateField({
  label,
  disabled,
  initialDate,
  finalDate,
  setInitialDate,
  setFinalDate,
  pattern = "br",
  disablePrefixLabels = false,
  validateMaxDate = false,
  validateDateRange = false,
}) {
  const handleInitialDateChange = (value) => {
    setInitialDate(value);
    if (validateDateRange && finalDate) {
      const dateFormat = pattern === "br" ? "DD/MM/YYYY" : "MM/DD/YYYY";
      const newInitialMoment = moment(value, dateFormat);
      const finalMoment = moment(finalDate, dateFormat);
      if (
        newInitialMoment.isValid() &&
        finalMoment.isValid() &&
        newInitialMoment.isAfter(finalMoment, "day")
      ) {
        setFinalDate("");
      }
    }
  };

  const isFinalDateValid = (current) => {
    if (validateMaxDate) {
      const hoje = moment().startOf("day");
      if (current.isAfter(hoje, "day")) {
        return false;
      }
    }
    if (validateDateRange && initialDate) {
      const dateFormat = pattern === "br" ? "DD/MM/YYYY" : "MM/DD/YYYY";
      const initialMoment = moment(initialDate, dateFormat);
      if (!initialMoment.isValid()) return true;
      return (
        current.isAfter(initialMoment, "day") ||
        current.isSame(initialMoment, "day")
      );
    }
    return true;
  };

  const isInitialDateValid = (current) => {
    if (validateMaxDate) {
      const hoje = moment().startOf("day");
      if (current.isAfter(hoje, "day")) {
        return false;
      }
    }
    if (validateDateRange && finalDate) {
      const dateFormat = pattern === "br" ? "DD/MM/YYYY" : "MM/DD/YYYY";
      const finalMoment = moment(finalDate, dateFormat);
      if (!finalMoment.isValid()) return true;
      return (
        current.isBefore(finalMoment, "day") ||
        current.isSame(finalMoment, "day")
      );
    }
    return true;
  };

  return (
    <Grid item xs={12} md={6} lg={4}>
      <FormGroup style={{ justifyContent: "center" }}>
        <FormLabel
          sx={{
            color: themeColorsDesingSystem.text.primary,
            fontSize: ".875rem",
            fontWeight: "600",
            lineHeight: 1.5,
            mb: 0,
            fontFamily: "Open Sans,sans-serif",
          }}
        >
          {label}
        </FormLabel>
        <Grid container spacing={2}>
          {!disablePrefixLabels && (
            <Grid item xs={1} alignItems="flex-end" justify="center">
              <Typography variant="caption">De:</Typography>
            </Grid>
          )}
          <Grid item xs={5}>
            <DateField
              value={initialDate}
              onChange={handleInitialDateChange}
              disabled={disabled}
              pattern={pattern}
              isValidDate={isInitialDateValid}
            />
          </Grid>
          {!disablePrefixLabels && (
            <Grid item xs={1} alignItems="flex-end" justify="center">
              <Typography variant="caption">Até:</Typography>
            </Grid>
          )}
          <Grid item xs={5}>
            <DateField
              value={finalDate}
              onChange={setFinalDate}
              isValidDate={isFinalDateValid}
              disabled={disabled || !initialDate}
              pattern={pattern}
            />
          </Grid>
        </Grid>
      </FormGroup>
    </Grid>
  );
}
